// Fastener Depot: sort Collection filters
// Handles fractions (formatted as "1-1/2" or "1/4"), hashtags (#10, #8), single numbers (1, 14), and alphabetical (I hope)

if ( $('.productgrid--sidebar-section').length > 0 ) {
  $('.filter-group').each(function(){
    var sortableFilterItems = [];
    var filterItems = $(this).find('li:not(.filter-item--toggle-more)').detach();
    filterItems.each(function(){
      $(this).removeClass('filter-item--hidden').removeAttr('data-hidden-default');
      var filterText = $.trim($(this).text());
      var splitFilterText = (filterText).split(' ');
      var filterWithoutUnit = splitFilterText[0];
      // If filter contains a number
      if ( /\d/.test(filterWithoutUnit) ) {
        // If filter contains a fraction
        if ( filterWithoutUnit.indexOf('/') > -1 ) {
          var fractionParts = filterWithoutUnit.split('/');
          var denominator = parseFloat(fractionParts[1]);
          if ( fractionParts[0].indexOf('-') > -1 ) {
            var numeratorParts = fractionParts[0].split('-');
            var wholeNumber = parseFloat(numeratorParts[0]);
            var numerator = parseFloat(numeratorParts[1]);
          } else {
            var numerator = parseFloat(fractionParts[0]);
            var wholeNumber = 0;
          }

          var float = ((numerator / denominator) + wholeNumber);
          sortableFilterItems.push({'original': $(this), 'readyToSort': float});
        // If filter contains a hashtag
        } else if ( filterWithoutUnit.indexOf('#') > -1 ) {
          var filterWithoutUnit = filterWithoutUnit.split(/[#]+/).pop();
          sortableFilterItems.push({'original': $(this), 'readyToSort': parseFloat(filterWithoutUnit * 0.01)});
        } else {
          sortableFilterItems.push({'original': $(this), 'readyToSort': parseFloat(filterWithoutUnit)});
        }
      // If filter doesn't contain a number
      } else {
        sortableFilterItems.push({'original': $(this), 'readyToSort': filterText});
      }
    });

    // Sort the array
    sortableFilterItems.sort(function(a, b){
      return a.readyToSort - b.readyToSort;
    });

      for (var i = 0; i < sortableFilterItems.length; i++ ) {
        // Hide all but the first 5 filters
        if ( ! $(this).hasClass('filter-group-active') ) {
          if ( i > 4 ) {
            sortableFilterItems[i].original.addClass('filter-item--hidden').attr('data-hidden-default', 'data-hidden-default');
          }
        }
  
        // Re-attach each filter item to the list
        $(this).find('.filter-group--wrapper').append(sortableFilterItems[i].original);
  
        // Put the "See More" toggle at the end of the list
        $(this).find('.filter-item--toggle-more').appendTo($(this).find('.filter-group--wrapper'));
      }
  });
}